module.exports = __webpack_public_path__ + "img/error-outfit.c871ccde.svg";